import $ from 'jquery';


import './../../scss/blocks/block-clublist.scss'; 


$(document).ready(function() {
    $('.clublist-btn').on('click', function() {
        $(this).parent().parent().toggleClass('active');
    });

    $('#show-more-clubs').on('click', function() {
        let hiddenItems = $('.clublist__item.hidden');
        let itemsToShow = 10;

        hiddenItems.slice(0, itemsToShow).removeClass('hidden');
        // Aktualizuje pole skrytých prvkov pre ďalší kliknutím
        hiddenItems = $('.clublist__item.hidden');
        // Skryje tlačidlo, ak už neexistujú ďalšie skryté prvky
        if (hiddenItems.length === 0) {
            $(this).hide();
        }
        clearLastItem();

    });

    clearLastItem();

    function clearLastItem () {
        let lastWithLast = $('.clublist__item.last')
        lastWithLast.removeClass('last')
        let lastVisibleItem = $('.clublist__item:visible:last');
        lastVisibleItem.addClass('last')
    } 

}) 
 
